import { Box as BoxComponent, Flex as FlexComponent } from '@rebass/grid';
import React from 'react';
import styled from 'styled-components';
export const Flex = styled(FlexComponent).withConfig({
  displayName: "Grid__Flex",
  componentId: "sc-1bhw5b4-0"
})(["text-align:", ";"], x => x.textAlign);
export const Box = styled(BoxComponent).withConfig({
  displayName: "Grid__Box",
  componentId: "sc-1bhw5b4-1"
})(["text-align:", ";"], x => x.textAlign);

/** Class variant of the Box element, needed by 'react-flip-move' to pass a ref */
export class BoxClass extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(BoxComponent, this.props, this.props.children);
  }

}